import { render, staticRenderFns } from "./MacaoGiftedGuide.vue?vue&type=template&id=24717d61&scoped=true&"
import script from "./MacaoGiftedGuide.vue?vue&type=script&lang=js&"
export * from "./MacaoGiftedGuide.vue?vue&type=script&lang=js&"
import style0 from "./MacaoGiftedGuide.vue?vue&type=style&index=0&id=24717d61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24717d61",
  null
  
)

export default component.exports